var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-card"},[(_vm.$scopedSlots['title'])?_c('div',{staticClass:"title"},[_vm._t("title")],2):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }